export default "__VITE_ASSET__lHanbvHG__"